import { useState } from 'react'
import { useForm } from 'react-hook-form'
import cx from 'classnames'
import SearchOutlinedIcon from '@material-ui/icons/SearchOutlined'
import { Typography, Button, TextField, InputAdornment } from '@material-ui/core'
import _ from 'lodash'

import { ArrowIcon } from 'icons'
import { useAlertForm } from '../../AlertFormProvider'
import styles from '../../ParameterAlertForm.module.scss'
import deviceStyles from './Devices.module.scss'
import DevicesFormList from 'common/components/DevicesFormList/DevicesFormList'
import { isInvalidDevice } from '../../deviceValidity'

// The user chooses the devices for the alert.
const Devices = () => {
  const {
    state: { typeSelected, selectedDevices },
    actions,
    meta: {
      translate,
      systems,
      systemsByGroup,
      parameterAlarmParamsBySystem,
      initialValues,
      formMode
    }
  } = useAlertForm()

  const { register, errors, setError, clearErrors } = useForm()

  const existingDeviceIds = initialValues?.existingDeviceIds ?? []
  const checkInvalidType = system =>
    isInvalidDevice({
      system,
      typeSelected,
      parameterAlarmParamsBySystem,
      existingDeviceIds,
      formMode
    })
  const validDeviceIds = systems
    .filter(system => !checkInvalidType(system))
    .map(system => system._id)

  const [isCheckAllDevices, setIsCheckAllDevices] = useState(
    validDeviceIds.length > 0 && validDeviceIds.every(id => selectedDevices.includes(id))
  )
  const [checkAllDevicesIsClicked, setCheckDevicesAllIsClicked] = useState(false)
  const [systemsGroupState, setSystemsGroupState] = useState(systemsByGroup)

  const isIndeterminate =
    checkAllDevicesIsClicked &&
    selectedDevices.length > 0 &&
    selectedDevices.length !== systems.length

  const handleChangeDevice = event => {
    const { checked, value } = event.target
    if (checked) {
      actions.setAlertDevices(prev => [...prev, value])
      clearErrors('selectedDevices')
    } else {
      actions.setAlertDevices(prev => prev.filter(id => id !== value))
    }
  }

  const handleSelectAllDevices = () => {
    setIsCheckAllDevices(prev => !prev)
    setCheckDevicesAllIsClicked(true)
    if (isCheckAllDevices) {
      actions.setAlertDevices([])
    } else {
      actions.setAlertDevices(validDeviceIds)
      clearErrors('selectedDevices')
    }
  }

  const handleSelectAllGroupDevices = (event, groupSystems) => {
    if (event.target.checked) {
      const newIds = groupSystems
        .filter(s => !selectedDevices.includes(s._id) && !checkInvalidType(s))
        .map(s => s._id)
      actions.setAlertDevices(prev => [...prev, ...newIds])
      clearErrors('selectedDevices')
    } else {
      const groupIds = groupSystems.map(s => s._id)
      actions.setAlertDevices(prev => prev.filter(id => !groupIds.includes(id)))
      clearErrors('selectedDevices')
    }
  }

  const filterExpressionChange = event => {
    const filtered = systems.filter(s =>
      s.name.toLowerCase().includes(event.target.value.toLowerCase())
    )
    setSystemsGroupState(_.groupBy(filtered, 'group'))
  }

  const handleNext = () => {
    if (selectedDevices.length === 0) {
      setError('selectedDevices', { shouldFocus: ' ' })
      return
    }
    actions.completeDevices()
  }

  return (
    <div>
      <div className={styles.nav}>
        <Typography className={styles.subheaderParams}>
          {translate('addParameterAlertModal.navParams')}
        </Typography>
        <Typography className={styles.subheaderValues}>
          {translate('addParameterAlertModal.navValues')}
        </Typography>
        <Typography className={deviceStyles.subheaderDevicesSelected}>
          {translate('addParameterAlertModal.navDevices')}
        </Typography>
        <Typography className={styles.subheaderParams}>
          {translate('addParameterAlertModal.navEmails')}
        </Typography>
      </div>

      <TextField
        variant='outlined'
        fullWidth
        type='search'
        onChange={filterExpressionChange}
        InputProps={{
          startAdornment: (
            <InputAdornment position='start'>
              <SearchOutlinedIcon />
            </InputAdornment>
          )
        }}
        id='searchDevice'
        name='searchDevice'
        placeholder={translate('searchDevice')}
        className={cx(styles.input)}
      />

      <DevicesFormList
        systems={systems}
        systemsGroupState={systemsGroupState}
        selectedDevices={selectedDevices}
        checkAllDevicesIsClicked={checkAllDevicesIsClicked}
        isCheckAllDevices={isCheckAllDevices}
        handleSelectAllDevices={handleSelectAllDevices}
        handleSelectAllGroupDevices={handleSelectAllGroupDevices}
        handleSelectDevice={handleChangeDevice}
        isIndeterminateDevices={isIndeterminate}
        translate={translate}
        register={register()}
        disabledValidation={checkInvalidType}
      />

      <div className={styles.wrapperError}>
        {errors.selectedDevices && (
          <div className={styles.error}>
            <small>{translate('validation.anyDeviceRequired')}</small>
          </div>
        )}
      </div>

      <div className={styles.buttonWrapper}>
        <Button
          fullWidth
          disableRipple
          variant='contained'
          className={styles.buttonSiguiente1}
          onClick={handleNext}
        >
          {translate('next')}
          <ArrowIcon className={styles.arrow} />
        </Button>
      </div>
      <div className={styles.buttonWrapper}>
        <Button
          fullWidth
          disableRipple
          variant='contained'
          className={styles.buttonCancelar}
          onClick={actions.goBack}
        >
          <ArrowIcon
            className={styles.arrow}
            direction='left'
          />
          {translate('back')}
        </Button>
      </div>
    </div>
  )
}

export default Devices
